import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherLogin from "@/pages/publisher/PublisherLogin";

export const Route = createFileRoute("/publisher/login")({
  head: () => pageHead("Publisher \u2014 Login \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: PublisherLogin,
});
